import React from 'react';
import { useParams } from 'react-router';

import { useAudience } from 'api/audiences';
import { PageContent, PageHeader } from 'components/page';

import AudienceForm from '../form';

interface Props {}

const AudienceEditPage = (props: Props) => {
  const { id: audienceId } = useParams<{ id: string }>();
  const audienceNumberId = audienceId ? Number(audienceId) : null;
  const { data: audience } = useAudience(audienceNumberId);

  return (
    <div>
      <PageHeader title={audience?.name} entity_id={audienceId} />
      {audience && (
        <PageContent>
          <AudienceForm initialValues={audience} isEditMode />
        </PageContent>
      )}
    </div>
  );
};

export default AudienceEditPage;
